import { BrandKitPage } from '@unfold/brand-kit';
import { PreferencesPage } from '@unfold/preferences';
import { StoriesPage } from '@unfold/stories';
import { LoginPage } from '@unfold/login';

export const routes = {
  login: {
    path: '/login',
    component: LoginPage,
  },
  requireAuth: [
    {
      path: '/brand',
      component: BrandKitPage,
    },
    {
      path: '/stories',
      component: StoriesPage,
    },
    {
      path: '/preferences',
      component: PreferencesPage,
    },
  ]
};
